import React from "react";
import VehicleManufacturerContainer from "../containers/Manufacturer/VehicleManufacturer/index";

const VehicleManufacturerPage = () => {
  return (
    <>
      <VehicleManufacturerContainer />
    </>
  );
};

export default VehicleManufacturerPage;
